import pcssCommon from '../src/Common/pcss/*.pcss';
import pcssAdmin from '../src/Admin/pcss/*.pcss';

import jsCommon from '../src/Common/js/*.js';
import jsAdmin from '../src/Admin/js/*.js';